import GenericMenuItem from './GenericMenuItem'
import { useGetIdentity, useTranslate } from 'react-admin'
import { Mail } from "@mui/icons-material"

const UserMailServiceConfigMenu = () => {

  const translate = useTranslate()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <GenericMenuItem 
      title={translate('resources.mailServiceConfig.name')}
      link={`/users/${identity.id}/mailServiceConfig`}
      icon={<Mail />}
    />
  )
}

export default UserMailServiceConfigMenu